import { render, staticRenderFns } from "./ConflictInstructionActionField.vue?vue&type=template&id=a2023ad8&scoped=true"
import script from "./ConflictInstructionActionField.vue?vue&type=script&lang=js"
export * from "./ConflictInstructionActionField.vue?vue&type=script&lang=js"
import style0 from "./ConflictInstructionActionField.vue?vue&type=style&index=0&id=a2023ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2023ad8",
  null
  
)

export default component.exports